import type { FunctionComponent } from 'react';

import styles from './SnippetsDrawerCode.module.less';

/**
 * Used for empty states in the code mirror views.
 * This is useful for both "you need to select something"
 * as well as "your data retention period has ended" messages.
 */
const CodeMirrorEmpty: FunctionComponent = ({ children }) => {
  return <div className={styles.empty}>{children}</div>;
};

export default CodeMirrorEmpty;
